import StepMessage from './StepMessage.vue'
import StepMessageForm from './StepMessageForm.vue'

export default {
  StepMessage,
  StepMessageForm
}



// WEBPACK FOOTER //
// ./src/components/StepMessage/index.js